import './Badge.css'

/** tone: 'neutral' | 'signal' | 'success' | 'warning' | 'danger' */
export default function Badge({ tone = 'neutral', children, className = '' }) {
  return <span className={`ll-badge ll-badge--${tone} ${className}`.trim()}>{children}</span>
}
